export type GreetingPeriod = 'morning' | 'afternoon' | 'evening'

// Three periods because nl_BE has three greetings (goeiedag, goeienamiddag,
// goeieavond); fr_BE says bonjour for the first two.
export function greetingPeriod(date: Date = new Date()): GreetingPeriod {
  const hour = date.getHours()
  if (hour >= 5 && hour < 12) {
    return 'morning'
  }
  if (hour >= 12 && hour < 18) {
    return 'afternoon'
  }
  return 'evening'
}
